import { IYearMonth } from '@/coreDomainsModule/date';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { initPagingOptions, IPagingOptions } from '@/coreDomainsModule/paging';
import { ISupplierForecastResult } from '../domains/entities/supplierForecastData';
import { AllBusinessesForSupplierForecastAdapter } from '../adapter/allBusinessesForSupplierForecastAdapter';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { SupplierForecastRepository } from '@/coreInfrastructureModule/Repositories/SupplierForecastRepository';
import { FilterService } from '@/coreDomainsModule/services/filterService';

/**
 * 仕入先内示ページで全取引を表示するために、取引をまとめて取得してUIに渡すユースケース
 */
export class GetAllSupplierForecastUseCase {
  private defaultPagingOptions: IPagingOptions = initPagingOptions(30); // TODO: ページごとに変わる可能性あるので要確認

  /**
   * DBから受領用内示に紐づく取引のうち、指定した受領月に該当する取引を取得する
   * @param repository - リポジトリ
   * @param yearMonthInfoCreatedForecast - 表示する内示の受領月
   * @param pagingOptions - ページングオプション
   * @param sortKey - ソートキー
   * @param isAsc - 昇順かどうか
   * @param filterItems - フィルター項目
   */
  public async Execute(
    repository: SupplierForecastRepository,
    yearMonthInfoCreatedForecast: IYearMonth,
    pagingOptions?: IPagingOptions,
    sortKey?: string,
    isAsc?: boolean,
    filterItems?: FilterContentItem[]
  ): Promise<INetworkResult<ISupplierForecastResult, Error>> {
    try {
      const usePagingOptions = pagingOptions || this.defaultPagingOptions;
      const sortType = isAsc ? 'ASC' : 'DESC';
      const useFilterItem =
        filterItems !== undefined && filterItems.length > 0 ? FilterService.convertFilterObject(filterItems) : undefined;
      const result = await repository.getAll(
        sortType,
        usePagingOptions.pageSize,
        usePagingOptions.offset,
        yearMonthInfoCreatedForecast.year,
        yearMonthInfoCreatedForecast.month,
        sortKey,
        useFilterItem
      );
      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      const businessListForecastForReceiptResult = AllBusinessesForSupplierForecastAdapter.adapt(result.status.data);
      return {
        status: {
          type: 'success',
          data: businessListForecastForReceiptResult,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
